import { adapter, CMSPAGES_FEATURE_KEY, CmsPagesPartialState, CmsPagesState } from './cmsPages.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const getCmsPagesState = createFeatureSelector<
  CmsPagesPartialState,
  CmsPagesState
>(CMSPAGES_FEATURE_KEY);

const { selectAll, selectEntities } = adapter.getSelectors();

const getError = createSelector( getCmsPagesState, (state:CmsPagesState) => state.error );

const getAllCmsPages = createSelector(
  getCmsPagesState,
  selectAll
);

const getAllCmsPagesById = createSelector(
  getCmsPagesState,
  selectEntities
);

const getLastCreatedId = createSelector( getCmsPagesState, (state:CmsPagesState) => state.lastCreatedId );

const getIsSearching = createSelector( getCmsPagesState, (state:CmsPagesState) => state.isSearching );

const getSearchResultIds = createSelector( getCmsPagesState, (state:CmsPagesState) => state.searchResultIds );

const getActualPage = createSelector( getCmsPagesState, (state:CmsPagesState) => state.actualPage );

const getSearchResults = createSelector( getAllCmsPagesById, getSearchResultIds, (entities, searchResultIds) => {
  return searchResultIds.map(id => entities[id]);
});

const getPartnerLegals = createSelector( getCmsPagesState, (state: CmsPagesState) => state.partnerLegals);

export const CmsPagesQuery = {
  getError,
  getAllCmsPages,
  getAllCmsPagesById,
  getLastCreatedId,
  getIsSearching,
  getSearchResults,
  getActualPage,
  getPartnerLegals
};
